import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken = process.env.EXPO_PUBLIC_MAP_BOX_SECRET_PUBLIC

export default mapboxgl
